/**
 * @format
 * @flow strict-local
 */
// DEPENDENCIES

import React, {
	useEffect,
	useState
} from "react";
import {
	withTranslation
} from "react-i18next";
import {
	connect
} from "react-redux";
import {
	Navigate,
	Route,
	Routes,
	useLocation
} from "react-router-dom";
import {
	compose
} from "redux";

//import GlobalHistory from "./components/GlobalHistory";
//import Loader from "./components/Loader"; // maybe call it screenLoader?
//import Notification from "./components/Notification";

import historyHelper from "./helpers/history";
import storeHelper from "./helpers/store";
import utilsHelper from "./helpers/utils";

import router from "./router";

import GlobalStyles from "./styled/styled-globals";

// INIT

/**
 * mapStateToProps - ...
 * 
 * @param {object} state ...
 */
const mapStateToProps = (state) => {
	return {
		...state
	};
};

// COMPONENT

const App = (props) => {
	const [
		isRenderReady, 
		setIsRenderReady
	] = useState(false);
	const [
		notificationProps, 
		setNotificationProps
	] = useState(null);

	// Lifecycle

	// Note - Run on bootstrap
	useEffect(
		() => {
			storeHelper.dispatch( 
				"SET_APP_NOTIFICATION", 
				{}
			);
		}, 
		[]
	);

	// Note - Run when props.SESSION.app.notification change
	useEffect(
		() => {
			if(
				!isRenderReady || 
				utilsHelper.isObjectEmpty(props.SESSION.app.notification)
			) {
				if(!isRenderReady) {
					setIsRenderReady(true);
				}

				return;
			}
			console.log(props.SESSION.app.notification);
			/*
			setNotificationProps({
				createdAt: Date.now(), //... Date or moment?
				...props.SESSION.app.notification
			});
			*/
    	}, 
		[props.SESSION.app.notification]
	);

	// Render

	/**
	 * render - ...
	 */
	//<GlobalHistory />
	//<Loader />
	//<Notification />
	const render = () => {
		return (
			<>
				<GlobalStyles />
				<Routes>
					<Route
						element={<Navigate 
							replace
							to="/auth/sign-in"
						/>}
						path="/" 
					/>
					{router.map((routeItem) => {
						const ScreenComponent = routeItem.screenComponent;
						const ViewComponent = routeItem.viewComponent;
			
						return (
							<Route
								element={<ViewComponent>
									<ScreenComponent />
								</ViewComponent>}
								key={routeItem.path}
								path={routeItem.path}
							/>
						);
					})}
				</Routes>
			</>
		);
	};

	return render();
};

// EXPORT

export default compose(
		withTranslation(), 
		connect(mapStateToProps)
	)(App)
;
